import { gql } from "@apollo/client";

export const SET_TERMINAL_IN_CALIBRATION_MODE = gql`
mutation SetInCalibrationMode($domain: String!, $terminalid: Int!, $state: Boolean!) {
    terminal {
      setInCalibrationMode(domain: $domain, terminalid: $terminalid, state: $state) {
        code
        success
        message
      }
    }
  }
`

export interface SetTerminalInCalibrationMode {
  domain: string
  terminalid: number
  state: boolean
}

interface SetTerminalCalibration {
  code: string
  success: boolean
  message: string
}

export interface SetTerminalCalibrationResponse {
  terminal: {
    setInCalibrationMode: SetTerminalCalibration 
  }
}